export const KatalogEvidencijaPoPotrebiResourcesDE: KatalogEvidencijaPoPotrebiResourcesBSInterface =
  {
    title: "Evidenz nach Bedarf",
    errorLoading:
      "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
    placeholder: "Evidenz nicht gefunden.",
  };

// TODO: Translate json
export const JSON_VRSTE_EVIDENCIJE = [
  { value: "TEMPLATE", label: "Vorlage" },
  { value: "EVIDENCIJA", label: "Evidenz" },
];

export const JSON_TYPE_EVIDENCIJE = [
  {
    value: "REGULAR",
    label: "Regelmäßig",
  },
  { value: "OCCASIONALLY", label: "Nach Bedarf" },
];

export interface KatalogEvidencijaPoPotrebiResourcesBSInterface {
  title: string;
  errorLoading: string;
  placeholder: string;
}
